/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pantallaInicioControllerEditarPantallaInicioPorUsuario } from '../fn/paciente-pantalla-de-inicio/pantalla-inicio-controller-editar-pantalla-inicio-por-usuario';
import { PantallaInicioControllerEditarPantallaInicioPorUsuario$Params } from '../fn/paciente-pantalla-de-inicio/pantalla-inicio-controller-editar-pantalla-inicio-por-usuario';
import { pantallaInicioControllerObtenerPantallaInicioPorUsuario } from '../fn/paciente-pantalla-de-inicio/pantalla-inicio-controller-obtener-pantalla-inicio-por-usuario';
import { PantallaInicioControllerObtenerPantallaInicioPorUsuario$Params } from '../fn/paciente-pantalla-de-inicio/pantalla-inicio-controller-obtener-pantalla-inicio-por-usuario';
import { PantallaInicioIdDto } from '../models/pantalla-inicio-id-dto';

@Injectable({ providedIn: 'root' })
export class PacientePantallaDeInicioService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pantallaInicioControllerObtenerPantallaInicioPorUsuario()` */
  static readonly PantallaInicioControllerObtenerPantallaInicioPorUsuarioPath = '/api/pantalla-inicio/obtener-pantalla-inicio';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pantallaInicioControllerObtenerPantallaInicioPorUsuario()` instead.
   *
   * This method doesn't expect any request body.
   */
  pantallaInicioControllerObtenerPantallaInicioPorUsuario$Response(params?: PantallaInicioControllerObtenerPantallaInicioPorUsuario$Params, context?: HttpContext): Observable<StrictHttpResponse<PantallaInicioIdDto>> {
    return pantallaInicioControllerObtenerPantallaInicioPorUsuario(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pantallaInicioControllerObtenerPantallaInicioPorUsuario$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pantallaInicioControllerObtenerPantallaInicioPorUsuario(params?: PantallaInicioControllerObtenerPantallaInicioPorUsuario$Params, context?: HttpContext): Observable<PantallaInicioIdDto> {
    return this.pantallaInicioControllerObtenerPantallaInicioPorUsuario$Response(params, context).pipe(
      map((r: StrictHttpResponse<PantallaInicioIdDto>): PantallaInicioIdDto => r.body)
    );
  }

  /** Path part for operation `pantallaInicioControllerEditarPantallaInicioPorUsuario()` */
  static readonly PantallaInicioControllerEditarPantallaInicioPorUsuarioPath = '/api/pantalla-inicio/editar-pantalla-inicio';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pantallaInicioControllerEditarPantallaInicioPorUsuario()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pantallaInicioControllerEditarPantallaInicioPorUsuario$Response(params: PantallaInicioControllerEditarPantallaInicioPorUsuario$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pantallaInicioControllerEditarPantallaInicioPorUsuario(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pantallaInicioControllerEditarPantallaInicioPorUsuario$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pantallaInicioControllerEditarPantallaInicioPorUsuario(params: PantallaInicioControllerEditarPantallaInicioPorUsuario$Params, context?: HttpContext): Observable<void> {
    return this.pantallaInicioControllerEditarPantallaInicioPorUsuario$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
